export default function ClientDetails(){
  return {
    restrict: "E",
    template: require("./ClientDetails.html"),
    controller: function(AuthService, KontaktService){
      this.kontakt = {};
      KontaktService.get(AuthService.user.odberatel.id)
      .then(k => this.kontakt = k);
    },
    controllerAs: "ctrl"
  }
}


// WEBPACK FOOTER //
// ./src/Menu/ClientDetails.js